import styled from 'styled-components'
import { boldFont, gray500, grey400, lg, sm, xs } from 'src/theme/variables'
import { makeStyles } from '@material-ui/core'

export const Header = styled.header<{ $bgUri: string }>`
  background-color: ${(props) => props.theme.colors.primaryLight};
  background-image: ${(props) => `url("${props.$bgUri}")`};
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;
  display: flex;
  //   &:after {
  //     content: "";
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     width: 101%;
  //     height: 315px;
  //     background: rgba(var(--Mprimary), 0.8);
  //     background: linear-gradient(to bottom, rgba(var(--Mprimary), 0.3) 0%, rgba(var(--Mprimary), 1) 100%);
  //     z-index: -1;
  //   }
`

export const Heading = styled.div`
  background-color: ${gray500};
  border-radius: 8px;
  text-align: center;
  min-height: 140px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 0;
  }
`

export const StepList = styled.div`
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 0;
  right: 0;
  width: 80%;
  margin: auto;
  transform: translateY(-50%);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 599px) {
    display: none;
  }
`

export const StepLabel = styled.button`
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background-color: ${gray500};
  box-shadow: none !important;
  border: none !important;
  /* background-color: rgba(var(--Mblue), 1); */
  color: ${(props) => props.theme.colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
  transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
`
export const StepBox = styled.div<{ $isActive?: boolean }>`
  flex: 1 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  &:not(:first-child)::after,
  &:not(:first-child)::before {
  }
  &:not(:first-child)::after {
    content: '';
    position: absolute;
    z-index: -1;
    top: 50%;
    left: 0;
    transform: translate(calc(-50% + (68px / 2) - 1px), -50%);
    height: 20px;
    width: 100%;
    background-color: ${grey400};
    transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  }
  ${(props) => {
    if (props.$isActive) {
      return `
      &:not(:first-child)::after{
        background-color: ${props.theme.colors.primary};
        }
        ${StepLabel}{
            background-color: ${props.theme.colors.primary};
            color: ${props.theme.colors.white};
        }
        `
    }
    {
      return ''
    }
  }}
`

export const useStyles = makeStyles((theme) => ({
  root: {
    margin: '10px 0 10px 10px',
    boxShadow: '0 0 10px 0 rgba(33,48,77,0.10)',
  },
  controlStyle: {
    backgroundColor: gray500,
    padding: lg,
    borderRadius: sm,
  },
  backButton: {
    marginRight: sm,
    fontWeight: boldFont,
    color: theme.palette.secondary.main,
  },
  nextButton: {
    fontWeight: boldFont,
  },
}))
